<template>
  <v-container>
    <o-main-progress v-if="loading"/>
    <div v-else>
      <Cabecera :incrustado="true" :tipoModuloActual="this.modulosStepper[this.step - 1].tipo"/>
      <v-stepper 
        class="proceso-pago"
        v-model="step"
        :alt-labels="!$vuetify.breakpoint.mdAndDown"
        :vertical="$vuetify.breakpoint.mdAndDown"
      >
        <component 
          v-if="modulosStepper.length > 1"
          :is="!$vuetify.breakpoint.mdAndDown ? 'v-stepper-header' : 'v-flex'"
          class="elevation-0"
          :class="$vuetify.breakpoint.mdAndDown ? 'proceso-pago-header' : ''"
        >
          <template
            v-for="(item, index) in modulosStepper"
          >
            <v-stepper-step 
              :key="'step' + item.tipo"
              :complete="step > index + 1 || item.tipo === 'resumen' || item.tipo === 'condiciones'"
              :step="index + 1"
              :color="item.tipo === 'resumen' && step != modulosStepper.length ? 'grey' : 'primary'"
            >
              <span 
                class="textoAjustado"
                :class="{
                  'text-xs-center' : !$vuetify.breakpoint.mdAndDown,
                  'grey--text': item.tipo === 'resumen' && step != modulosStepper.length
                }"
              >
                {{getNombreModulo(item.tipo)}}
              </span>
            </v-stepper-step>
            <v-divider :key="'divider' + item.tipo" v-if="index + 1 < modulosStepper.length" :vertical="$vuetify.breakpoint.mdAndDown"/>
          </template>
        </component>
        <v-stepper-items>
          <template
            v-for="(item, index) in modulosStepper"
          >
          <v-stepper-content :key="'content'+item.tipo" :step="index + 1">
            <component 
              :is="capitalize(item.tipo)"
              :ref="item.tipo"
              :actual="index === step - 1"
              incrustado
              :cargandoExterior="cargandoSiguientePaso"
              @error="errorPaso()"
              @terminado="terminarPaso(item, $event)"
              v-if="step>=index + 1"
            />
          </v-stepper-content>
          </template>
        </v-stepper-items>
        <v-layout justify-end mr-2 mb-2>
          <v-btn
            v-if="mostrarGuardarSalirActivado"
            @click="mostrarGuardarSalir = true"
          >
            {{$t('general.misc.guardarYSalir')}}
          </v-btn>
        </v-layout>
      </v-stepper>
    </div>
    <v-fade-transition>
      <custom-dialog v-if="mostrarGuardarSalir" v-model="mostrarGuardarSalir" :noCerrar="noCerrarGuardarSalir">
        <GuardarSalir :terminado="terminado" :step="step + sumaExtraPaso" :waitingForLoad="waitingForLoad" @continuar="continuar"/>
      </custom-dialog>
    </v-fade-transition>
    
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'
import Pago from '@/components/reservas/pagos/Pago'
import Contrato from '@/components/reservas/contratos/Contrato'
import Kyc from '@/components/reservas/kyc/Kyc'
import Condiciones from '@/components/reservas/condiciones/Condiciones'
import Documentacion from '@/components/reservas/documentacion/Documentacion'
import GuardarSalir from '@/components/incrustado/GuardarSalir'
import ValidacionDocumentacion from '@/components/reservas/validacionDocumentacion/ValidacionDocumentacion'
import Pbc from '@/components/reservas/pbc/Pbc'
import Resumen from '@/components/incrustado/Resumen'
import Velocity from 'velocity-animate'
import modulos from '@/mixins/modulos'
import Cabecera from '@/components/Cabecera'

export default {
  mixins: [rules, modulos],
  components: {
    Pago,
    Contrato,
    Kyc,
    Condiciones,
    Pbc,
    Documentacion,
    GuardarSalir,
    Resumen,
    ValidacionDocumentacion,
    Cabecera
  },
  data () {
    return {
      aceptado: false,
      waitingForLoad: false,
      usermail: null,
      nombre: null,
      valid: false,
      step: 1,
      mostrarGuardarSalir: false,
      noCerrarGuardarSalir: false,
      mostrarValidar: false,
      terminado: false,
      cargandoSiguientePaso: false,
      loading: false,
      cambiado: true,
      sumaExtraPaso: 0
    }
  },
  computed: {
    ...mapGetters({
      modulos: 'modulosOrdenes/modulos/getAll',
      reserva: 'reservas/_id/getActual'
    }),
    modulosStepper () {
      let retorno = this.modulos.concat(
        {
          nombre: this.$t('pages.incrustado.procesoFinalizado'),
          tipo: 'resumen'
        }
      )
      // Quitar paso pago si no hay importe
      if (this.reserva != null && this.reserva.importeReserva === 0) {
        retorno = retorno.filter(x => (x.tipo !== 'pago'))
      }
      return retorno
    },
    mostrarGuardarSalirActivado () {
      if (this.modulosStepper[this.step - 1]) {
        switch (this.modulosStepper[this.step - 1].tipo) {
          case 'contrato':
          case 'kyc':
          case 'documentacion':
          case 'pago':
            return true
          case 'resumen':
            return false
        }
      }
      return false
    }
  },
  mounted () {
    window.addEventListener('beforeunload', this.alertPreRefresh)
  },
  async created () {
    try {
      this.loading = true
      await this.loadReserva(this.reserva.id)
      await this.cargarSiguienteModulo(this.modulosStepper[this.step])
      this.loading = false
    } catch (error) {
      this.loading = false
      this.addAlert({texto: error.message, color: 'error'})
      this.$router.push({name: 'incrustado.mensajeError'})
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.cambiado) {
      let respuesta = confirm(this.$t('general.misc.alertPreRefresh'))
      if (respuesta) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.alertPreRefresh)
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadReserva: 'reservas/_id/load',
      loadMaestros: 'maestros/load',
      loadAllCompradores: 'compradores/loadAll',
      loadAllContratos: 'contratos/loadAll',
      loadAllCarpetas: 'carpetas/loadAllDocumentacion',
      enviarCorreoStepper: 'reservas/enviarCorreoStepper',
      loadInmueble: 'promociones/inmuebles/loadSinComprobar',
      loadTiposDocumentos: 'maestros/loadTiposDocumentos',
      loadOtp: 'configuracion/variablesConfiguracion/loadOtp',
      loadPromocionRepresentantes: 'promocionesRepresentantes/loadAll',
      loadPromocionPlantillas: 'promocionesPlantillas/loadAll'
    }),
    alertPreRefresh (e) {
      if (this.cambiado) {
        let message = this.$t('general.misc.alertPreRefresh')
        e = e || window.event
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = message
        }
        // For Safari
        return message
      }
    },
    capitalize (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    },
    async cargarSiguienteModulo (item) {
      try {
        this.cargandoSiguientePaso = true
        switch (item.tipo) {
          case 'pago':
            await this.loadReserva(this.reserva.id)
            await this.loadInmueble({
              codigoPromocion: this.reserva.codigoPromocion,
              codigoActivo: this.reserva.codigoActivo,
              alquiler: this.reserva.cod_tipo_operacion === 'ALQ'
            })
            break
          case 'contrato':
            await Promise.all([
              this.loadMaestros(),
              this.loadTiposDocumentos(),
              this.loadAllCompradores(this.reserva.id),
              this.loadOtp(),
              this.loadPromocionPlantillas(this.reserva.codigoPromocion),
              this.loadPromocionRepresentantes(this.reserva.codigoPromocion)
            ])
            break
          case 'kyc':
            await Promise.all([
              this.loadMaestros(),
              this.loadTiposDocumentos(),
              this.loadAllCompradores(this.reserva.id)
            ])
            break
          case 'documentacion':
            await Promise.all([
              this.loadReserva(this.reserva.id),
              this.loadAllCarpetas(this.reserva.id)
            ])
            await this.loadAllCompradores(this.reserva.id)
            break
          case 'resumen':
            this.cambiado = false
            await this.enviarCorreoStepper({
              id: this.reserva.id,
              step: this.step + 1
            })
            break
          case 'condiciones':
            this.cambiado = false
            break
          default:
            break
        }
        if (item.tipo !== 'resumen' && item.tipo !== 'validacionDocumentacion' && item.tipo !== 'pbc') {
          if (!this.comprobarEstadoActual(item.tipo, this.reserva)) {
            this.errorPaso()
            this.addAlert({texto: this.$t('pages.incrustado.errorStepper'), color: 'error'})
            return
          }
          if (!this.comprobarEstadoAnterior(item.tipo, this.reserva)) {
            this.errorPaso()
            this.addAlert({texto: this.$t('pages.incrustado.errorStepper'), color: 'error'})
            return
          }
        }
        this.step++
        this.cargandoSiguientePaso = false
      } catch (error) {
        console.log(error)
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: this.$t('pages.incrustado.errorSiguientePaso'), color: 'error'})
        }
      }
    },
    errorPaso () {
      this.cambiado = false
      this.$router.push({name: 'incrustado.mensajeError'})
    },
    async terminarPaso (item, payload) {
      switch (item.tipo) {
        case 'pago':
          if (payload === 'stripe') {
            await this.cargarSiguienteModulo(this.modulosStepper[this.step])
            this.$refs.pago[0].mostrarStripe = false
          } else if (payload === 'gratis') {
            await this.cargarSiguienteModulo(this.modulosStepper[this.step])
          } else {
            this.sumaExtraPaso = 1 // Sumo 1 en pago por transferencia (pte. validacion)
            this.mostrarGuardarSalir = true
            this.noCerrarGuardarSalir = true
            this.terminado = true
          }
          break
        case 'contrato':
          if (payload) {
            await this.cargarSiguienteModulo(this.modulosStepper[this.step])
          } else { // Guardar y salir en contrato o firma por correo, se envía el correo y punto
            this.cargandoSiguientePaso = true
            await this.enviarCorreoStepper({
              id: this.reserva.id,
              step: this.step - 1
            })
            this.mostrarGuardarSalir = true
            this.noCerrarGuardarSalir = true
            this.cargandoSiguientePaso = false
            this.waitingForLoad = false
            this.terminado = true
          }
          break
        case 'kyc':
          if (payload) {
            await this.cargarSiguienteModulo(this.modulosStepper[this.step])
            this.$refs.kyc[0].mostrarTerminado = false
          } else {
            this.cargandoSiguientePaso = true
            await this.enviarCorreoStepper({
              id: this.reserva.id,
              step: this.step - 1
            })
            this.waitingForLoad = false
            this.cargandoSiguientePaso = false
            this.terminado = true
          }
          break
        case 'documentacion':
          if (payload) {
            await this.cargarSiguienteModulo(this.modulosStepper[this.step])
          } else {
            this.cargandoSiguientePaso = true
            await this.enviarCorreoStepper({
              id: this.reserva.id,
              step: this.step - 1
            })
            this.mostrarGuardarSalir = true
            this.noCerrarGuardarSalir = true
            this.cargandoSiguientePaso = false
            this.waitingForLoad = false
            this.terminado = true
          }
          break
        case 'validacionDocumentacion':
        case 'pbc':
          this.cargandoSiguientePaso = true
          await this.enviarCorreoStepper({
            id: this.reserva.id,
            step: this.step - 1
          })
          this.mostrarGuardarSalir = true
          this.noCerrarGuardarSalir = true
          this.cargandoSiguientePaso = false
          this.waitingForLoad = false
          this.terminado = true
          break
        default:
          await this.cargarSiguienteModulo(this.modulosStepper[this.step])
          break
      }
    },
    async continuar () {
      this.noCerrarGuardarSalir = true
      switch (this.modulosStepper[this.step - 1].tipo) {
        case 'kyc': {
          this.waitingForLoad = true
          let res = await this.$refs.kyc[0].aceptar(false)
          if (res === undefined) {
            this.noCerrarGuardarSalir = false
            this.mostrarGuardarSalir = false
            this.waitingForLoad = false
          }
          break
        }
        case 'documentacion': {
          this.waitingForLoad = true
          let doc = await this.$refs.documentacion[0].aceptar(false)
          if (doc === undefined) {
            this.noCerrarGuardarSalir = false
            this.mostrarGuardarSalir = false
            this.waitingForLoad = false
          }
          break
        }
        case 'contrato': {
          this.waitingForLoad = true
          let cont = await this.$refs.contrato[0].aceptar(false)
          if (cont === undefined) {
            this.noCerrarGuardarSalir = false
            this.mostrarGuardarSalir = false
            this.waitingForLoad = false
          }
          break
        }
        default:
          try {
            this.waitingForLoad = true
            await this.enviarCorreoStepper({
              id: this.reserva.id,
              step: this.step - 1
            })
            this.waitingForLoad = false
            this.terminado = true
          } catch (error) {
            this.waitingForLoad = false
            this.addAlert({texto: error.message, color: 'error'})
          }
      }
    },
    getNombreModulo(tipo) {
      if (tipo === 'resumen') {
        return this.$t('pages.incrustado.procesoFinalizado')
      }
      return this.getTexto('modulos.' + tipo + (this.reserva.cod_tipo_operacion !== 'VTA' ? 'Alquiler' : ''))
    }
  },
  watch: {
    terminado (newVal) {
      if (newVal) {
        this.cambiado = false
        window.parent.postMessage('reserva_terminada', '*')
      }
    },
    step (newVal, oldVal) {
      if (newVal > oldVal) {
        Velocity(document.documentElement, 'scroll', {
          duration: 500,
          offset: 0,
          mobileHA: false
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/incrustado/stepper.vue